
import React from "react";
import {Box, Button, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";

import AccountSidebar from "../../components/general/orderHistory/accountSidebar";
import OrderHeaderBlock from "../../components/general/order/orderHeaderBlock";
import OrderLinesBlock from "../../components/general/order/orderLinesBlock";
import OrderFinancialsBlock from "../../components/general/order/orderFinancialsBlock";
import OrderAddressesBlock from "../../components/general/order/orderAddressesBlock";
import Images from "../../assets";
import {getRouteUrl} from "../../helpers/routing/getRouteUrl";
import {
    ROUTE_ADDRESSES,
    ROUTE_COUPONS,
    ROUTE_DETAILS,
    ROUTE_ORDER_HISTORY, ROUTE_RETURNS,
} from "../../routers/routes";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../locales/components/namespaces";
import {useDispatch} from "react-redux";
import {userLogout} from "../../actions/currentUser/actions";
import useOrderData from "../../hooks/orders/useOrderData";


const Order = () => {
    const history = useHistory()
    const { t } = useTranslation(DASHBOARD);
    const dispatch = useDispatch();
    const {id} = useParams();
    const {orderDetails,loading} = useOrderData({id})

    const accountMenuItems = [
        t("accountDetails"),
        t( "orderHistory"),
        t("addresses"),
        t("logout"),
    ];

    const handleLogout = () => {
        dispatch(userLogout());
        history.push(`/`)
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                py: { xs: 4, md: 6 },
                px: { xs: 2, md: 4 },
            }}
        >
            <Box
                sx={{
                    //width: "100%",
                    maxWidth: 1750,
                    mx: "auto",
                    bgcolor: "#E9E9E9",
                    borderRadius: "30px",
                    px: { xs: 2, md: 6 },
                    py: { xs: 4, md: 6 },
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Zen Maru Gothic', sans-serif",
                        fontWeight: 900,
                        fontSize: { xs: 24, md: 36 },
                        mr: { xs: 3, md: 55,lg:60 },
                        textAlign: "center",
                        mb: { xs: 3, md: 4 },
                        color: "#111111",
                    }}
                >
                    ORDER #{orderDetails?.orderHeader?.orderNumber}
                </Typography>

                <Grid
                    container
                    spacing={{ xs: 3, md: 4 }}
                    columnSpacing={{ xs: 1, md: 6, lg: 10 }}
                    sx={{
                        flexWrap: { xs: "wrap", md: "nowrap" },
                    }}
                >
                    <Grid item xs={12} md={3} lg={2}>
                        <AccountSidebar
                            items={accountMenuItems}
                            activeIndex={1}
                            onSelect={(index) => {
                                if (index === 0) history.push(getRouteUrl(ROUTE_DETAILS));
                                if (index === 1) history.push(getRouteUrl(ROUTE_ORDER_HISTORY));
                                if (index === 2) history.push(getRouteUrl(ROUTE_ADDRESSES));
                                if (index === 3) handleLogout();
                            }}
                        />
                        <Button
                            onClick={() => history.push(getRouteUrl(ROUTE_ORDER_HISTORY))}
                            sx={{
                                mt:2,
                                boxSizing: "border-box",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "10px 20px",
                                gap: "1px",
                                width: "118px",
                                height: "37px",
                                border: "1px solid #E5007E",
                                borderRadius: "120px",
                                backgroundColor: "transparent",
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontWeight: 700,
                                fontSize: "14px",
                                color: "#E5007E",
                                lineHeight: 1,
                                "&:hover": {
                                    backgroundColor: "#E5007E",
                                    color: "#FFFFFF",
                                    borderColor: "#E5007E",
                                },
                            }}
                        >
                            {t("Return")}
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={9} lg={10} sx={{flexGrow: 1}}>
                        <Box
                            sx={{
                                bgcolor: "#F0F0F0",
                                borderRadius: "20px",
                                p: { xs: 2, md: 4 },
                                display: "flex",
                                flexDirection: "column",
                                gap: { xs: 3, md: 5 },
                                //minWidth: 0,
                            }}
                        >
                            <OrderHeaderBlock header={orderDetails?.orderHeader} t={t} />
                            <OrderLinesBlock items={orderDetails?.orderItems} t={t} />
                            <OrderFinancialsBlock
                                totals={orderDetails?.orderTotals}
                                extraInfoText={orderDetails?.extraInfoText}
                                t={t}
                            />
                            <OrderAddressesBlock addresses={orderDetails?.addresses} />
                        </Box>
                    </Grid>
                </Grid>

            </Box>
        </Box>
    );
};

export default Order;
